import React, {Component} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import LoadingButton from "../LoadingButton";
import CommunicationMethodInput from "../communication_method/CommunicationMethodInput";
import upsertClientContactCommunicationMethodsMutation
    from "../../../queries/server/mutations/upsert_client_contact_communication_methods";
import editClientLocalMutation from '../../../queries/client_side/mutations/edit_client'
import removeClientContactMethodMutation from '../../../queries/server/mutations/remove_client_contact_contact_method'

class ClientContactCommunicationMethodItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            editing: false,
            ...props
        }
    }

    render() {
        const {client_id, contact_id} = this.props
        const {type, value, colour, contact_medium_id, editing, communication_method_id} = this.state

        if (editing) {
            return (
                <Mutation mutation={upsertClientContactCommunicationMethodsMutation}>
                    {(upsertClientContactCommunicationMethodsMutationFunc, {loading}) => (
                        <Mutation mutation={editClientLocalMutation}>
                            {(editClientLocalMutationFunc) => (
                                <CommunicationMethodInput
                                    contact_medium_id={contact_medium_id}
                                    contact_info={value}
                                    saving={loading}
                                    onContactMediumChanged={(contact_medium_id) => this.setState({contact_medium_id})}
                                    onContactInfoChanged={(value) => this.setState({value})}
                                    onCancel={() => this.setState({editing: false})}
                                    onSave={() => {
                                        upsertClientContactCommunicationMethodsMutationFunc({
                                            variables: {
                                                client_id,
                                                contact_id,
                                                data: [{
                                                    communication_method_id,
                                                    contact_medium_id,
                                                    contact_info: value
                                                }]
                                            }
                                        })
                                            .then(({data}) => {
                                                editClientLocalMutationFunc({variables: {data: data.upsertClientCommunicationMethod}})
                                                toast.success('Communication Method Updated', {autoClose: 2000})
                                                this.setState({editing: false})
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                    }}
                                />
                            )}

                        </Mutation>)}
                </Mutation>
            )
        }
        return (
            <div className="d-flex flex-row align-items-center justify-content-between border-bottom pt-2 pb-2">
                <FontAwesomeIcon color={colour || '#000'} icon={type}/>
                <p className="font-weight-light p-0 m-0 pl-2" style={{flex: 1}}>{value}</p>
                <LoadingButton size="sm" className="square-btn" color="warning" icon="edit" loading={false}
                               onClick={() => this.setState({editing: true})}/>
                <Mutation mutation={editClientLocalMutation}>
                    {(editClientLocalMutationFunc) => {
                        return (
                            <Mutation mutation={removeClientContactMethodMutation}>
                                {(removeClientContactMethodMutation, {loading}) => {
                                    return (
                                        <LoadingButton
                                            size="sm"
                                            className="ml-1 square-btn"
                                            color="danger"
                                            icon="trash-alt"
                                            loading={loading}
                                            onClick={() => {
                                                removeClientContactMethodMutation({
                                                    variables: {
                                                        client_id,
                                                        contact_id,
                                                        ids: [communication_method_id]
                                                    }
                                                })
                                                    .then(({data}) => {
                                                        editClientLocalMutationFunc({
                                                            variables: {
                                                                data: data.removeClientContactCommunicationMethods
                                                            }
                                                        })
                                                        toast.success('Communication Method Removed', {autoClose: 2000})
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                        />
                                    )
                                }}

                            </Mutation>)
                    }}
                </Mutation>
            </div>
        )
    }

}

ClientContactCommunicationMethodItem.propTypes = {
    type: PropTypes.string.isRequired,
    client_id: PropTypes.number.isRequired,
    contact_id: PropTypes.number.isRequired,
    contact_medium_id: PropTypes.number.isRequired,
    communication_method_id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
    colour: PropTypes.string,
}

export default ClientContactCommunicationMethodItem